import {SSEMessage} from '../types'
import {PhotoCompleteSSEMeta} from './types'

export type TopicProcessPhotoCompleteType = 'Photos.ProcessComplete'
export const TopicProcessPhotoComplete: TopicProcessPhotoCompleteType =
  'Photos.ProcessComplete'

export type ProcessPhotoMessageProperties = {
  completed: boolean
  error: string
}

export type ProcessPhotoCompleteEvent = {
  Response?: ProcessPhotoMessageProperties
  PhotoCompleteMeta?: PhotoCompleteSSEMeta
}

export function handleProcessPhotoSSE(
  msg: SSEMessage,
): ProcessPhotoCompleteEvent {
  const event: ProcessPhotoCompleteEvent = {}
  if (msg.Response) {
    event.Response = JSON.parse(msg.Response.Properties)
  }
  if (msg.PhotoCompleteMeta) {
    event.PhotoCompleteMeta = JSON.parse(msg.PhotoCompleteMeta.Properties)
  }
  return event
}
